import { useNavigate } from 'react-router-dom';
import colors from 'tailwindcss/colors';

import Logo from '../navbar/Logo';
import { BRAND_COLORS, ConsumerRouteList } from '../utils/constants';

import { AppRoutes } from '@/interfaces/routes/AppRoutes';
import { ConsumerRoutes } from '@/interfaces/routes/ConsumerRoutes';

const ConsumerSidebar = () => {
	const navigate = useNavigate();
	const isCurrentRoute = (path: string | null) => location.pathname === path;

	return (
		<div className="flex flex-col relative p-4 rounded bg-white border-r gap-4 h-full overflow-auto">
			<div className="flex justify-center w-full">
				<Logo href={AppRoutes.Landing} width={180} height={32} />
			</div>
			<div>
				<div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 relative gap-4 py-2">
					<div className="flex flex-col justify-start items-start self-stretch flex-grow-0 flex-shrink-0 gap-4">
						{ConsumerRouteList.map(({ name, path, icon: Icon, showInMenu }) =>
							showInMenu ? (
								<button
									key={name}
									className={`w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-100
                ${
									isCurrentRoute(path)
										? 'text-purpleBrand-700 font-semibold border-l-4 border-purpleBrand-700'
										: location.pathname === ConsumerRoutes.AddProfile &&
										  path === ConsumerRoutes.Profile
										? 'text-purpleBrand-700 font-semibold border-l-4 border-purpleBrand-700'
										: 'text-gray-500'
								}`}
									onClick={() => navigate(path)}
								>
									{Icon && (
										<Icon
											fill={
												isCurrentRoute(path)
													? BRAND_COLORS.PURPLE_500
													: location.pathname === ConsumerRoutes.AddProfile &&
													  path === ConsumerRoutes.Profile
													? BRAND_COLORS.PURPLE_500
													: colors.gray[500]
											}
										/>
									)}

									<span className="text-md">{name}</span>
								</button>
							) : null,
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConsumerSidebar;
